import React, { useEffect, useState } from "react";
import about1 from "../../assets/img/about/14.png";
import about2 from "../../assets/img/about/13.png";
import about3 from "../../assets/img/icon/31.svg";
import about4 from "../../assets/img/icon/32.svg";

const mediaItems = [
  {
    id: 1,
    title: "Web Development",
    image: about3,
    skill: "90%",
    skillValue: 90,
  },
  {
    id: 2,
    title: "Cloud Solutions",
    image: about4,
    skill: "80%",
    skillValue: 80,
  },
  {
    id: 3,
    title: "Cloud Solutions",
    image: about4,
    skill: "95%",
    skillValue: 95,
  },
];

function AboutUs() {
  const [progressStyles, setProgressStyles] = useState({});

  useEffect(() => {
    const newStyles = {};
    mediaItems.forEach((item) => {
      newStyles[item.id] = {
        width: `${item.skillValue}%`,
        animationDuration: "1s",
      };
    });
    setProgressStyles(newStyles);
  }, []);

  return (
    <>
      <div className="about-area pd-top-120 pd-bottom-110">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div
                className="about-thumb-inner p-xl-5 pt-4 wow animated fadeInLeft"
                data-wow-duration="1.5s"
                data-wow-delay="0.3s"
              >
                <img className="animate-main-img" src={about1} alt="img" />
                <img className="main-img m-md-4" src={about2} alt="img" />
              </div>
            </div>
            <div
              className="col-lg-6 align-self-center wow animated fadeInRight"
              data-wow-duration="1.5s"
              data-wow-delay="0.3s"
            >
              <div className="section-title mt-5 mt-lg-0">
                <h6 className="sub-title">ABOUT US</h6>
                <h2 className="title">
                  Transforming Businesses Through <span>Software</span>{" "}
                  Innovation
                </h2>
                <p className="content mb-4 mb-xl-5">
                  We are an IT company dedicated to delivering innovative
                  software solutions. Our team focuses on enhancing efficiency
                  and driving growth for businesses. With a commitment to
                  quality and customer satisfaction, we strive to set new
                  industry standards and empower our clients to succeed in the
                  digital age.
                </p>

                {mediaItems.map((item) => (
                  <div
                    key={item.id}
                    className="media box-shadow p-3 border-radius-5 mb-3"
                  >
                    <div className="media-left me-3">
                      <img src={item.image} alt="img" />
                    </div>
                    <div className="media-body">
                      <div className="single-progressbar">
                        <h6>{item.title}</h6>
                        <div className="skill">
                          <div
                            className="skill-bar skill1 wow slideInLeft animated"
                            style={progressStyles[item.id]}
                          ></div>
                          <p className="skill-count1">
                            <span className="counter">{item.skillValue}</span> %
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AboutUs;
